const AuthGroup = `
  id
  name
`;

export default AuthGroup;
